import { Disease, DiseaseQuery } from '@dreryk/medical-dictionaries-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { BindingCreator } from '@dreryk/react-common';
import { Autosuggest, StrongText, StyledFlex, Text, TextSeparator, TextSeparatorType } from '@dreryk/react-components';
import { TextPattern } from '@dreryk/watermelon';

import { patientMedicalInformationTranslationKeys } from '../../../../translations';

const t = patientMedicalInformationTranslationKeys.chronicDisease.form.create;

const diseaseLabelExtractor = ({ icd10Code, name }: Disease): string => `${icd10Code} ${name}`;
const diseaseItemRenderer = ({ name, icd10Code }: Disease): JSX.Element => {
   return (
      <TextSeparator separator={TextSeparatorType.SPACE}>
         <StrongText testId={'name'}>{name}</StrongText>
         <Text testId={'code'}>{`(${icd10Code})`}</Text>
      </TextSeparator>
   );
};

const diseasesSearchCreator = (searchText: string | null) => {
   return async (): CqrsQueryPerformResult<Disease[]> =>
      performCqrsQuerySearch<Disease>(() => {
         const query = new DiseaseQuery();
         if (searchText) {
            query.nameOrIcd10Code = TextPattern.anywhereIgnoreCase(searchText);
         }
         return query;
      });
};

const DISEASE_SELECTOR_FIELD_NAME = 'disease';
type DiseaseSelectorType = Disease | null;

export type DiseaseSelectorFormBeanPart = { [DISEASE_SELECTOR_FIELD_NAME]: DiseaseSelectorType };
type DiseaseSelectorProps = { readonly register: BindingCreator<DiseaseSelectorFormBeanPart> };

export const DiseaseSelector = (props: DiseaseSelectorProps): JSX.Element => {
   return (
      <StyledFlex>
         <Autosuggest<Disease>
            minChars={2}
            keyProperty={'icd10Code'}
            placeholder={t.disease.placeholder}
            itemRenderer={diseaseItemRenderer}
            labelExtractor={diseaseLabelExtractor}
            controller={props.register(DISEASE_SELECTOR_FIELD_NAME, { required: true })}
            searchCreator={diseasesSearchCreator}
            testId={'disease'}
            label={t.disease.label}
         />
      </StyledFlex>
   );
};
